import React, { createContext, useContext, useState } from "react";

const JoyrideContext = createContext<any>(null);

export const JoyrideProvider = ({ children }) => {
  const [startJoyRide, setStartJoyRide] = useState(false);
  const [selectedTab, setSelectedTab] = useState<string>("");
  return (
    <JoyrideContext.Provider value={{ startJoyRide, setStartJoyRide, selectedTab, setSelectedTab,}}>
      {children}
    </JoyrideContext.Provider>
  );
};

export const useJoyride = () => useContext(JoyrideContext);